module.exports = __webpack_public_path__ + "img/image2@2x.ce639736.png";